import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import {
  IMaxDownstreamDatasources,
  IMaxDownstreamWorkbooks
} from '../types/IMaxDownstreamConnections';
import { ITable } from '../types/ITable';
import { forceIsEmbeddedToFalse } from '../utils/CrassRequestHelper';

export interface IGetTablesParams extends IGetItemsParams {}

export interface IGetTablesResult extends IGetItemsResult {
  tables?: ITable[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetTablesRequest extends Request<
  IGetTablesParams,
  IGetTablesResult
> {
  constructor(params: IGetTablesParams) {
    // force isEmbedded to false as a workaround for
    // Defect 1214943: CRASS: Embedded Assets: inconsistent database/table count and content to due insufficient permission

    super('getTables', forceIsEmbeddedToFalse(params));
  }
}